import type { ItemsType } from "../../../../common-deprecated/redux/typeHelpers";
import { find } from "../../../../common-deprecated/utils";
import CarDataConsolidator from "../../../shared-logic/utils/classes/CarDataConsolidator";

export const hasVisibleExtras = (items: ItemsType, showPackExtras: boolean): boolean => {
    // Extras who are in packs only (These are not included in the items.extras)
    const extrasOnlyFromPacks = showPackExtras
        ? CarDataConsolidator.getExtrasFromPacks(items.packs).filter((packs) => !find(packs.id, items.extras))
        : [];
    const allExtras = [...extrasOnlyFromPacks, ...items.extras].sort((a, b) => a.sortIndex - b.sortIndex);
    return allExtras.some((item) => !item.isHidden);
};

export const getCategorizedExtrasCode = (
    code: string,
): {
    tracking: "show-all-extra-interior" | "show-all-extra-exterior";
    button: string;
    label: "showAllInteriorExtras" | "showAllExteriorExtras";
} => ({
    tracking: code === "INT" ? "show-all-extra-interior" : "show-all-extra-exterior",
    button: `button-show-all-extras-${code.substring(0, 3).toLowerCase()}`,
    label: code === "INT" ? "showAllInteriorExtras" : "showAllExteriorExtras",
});
